module.exports = __webpack_public_path__ + "static/media/policeCar_blue.48446978.svg";